/**
 * Shared selector for computing the link target of a Pending_Review_Surface
 * (sidebar badge, dashboard "Needs your attention" panel, Assessments list
 * `pending_review` filter). This is a pure function with no framework
 * imports so it can be used from both client and server code.
 *
 * Requirements: 4.2, 4.3
 */

export const PENDING_REVIEW_FILTERED_LIST_ROUTE =
  "/assessments/technical-alignment?filter=pending_review";

/**
 * Returns the link target for a Pending_Review_Surface given the current
 * set of `pending_review` assessment ids: a direct deep link to that
 * assessment's review page when there is exactly one (Req 4.2), or the
 * filtered-list route when there are zero or more than one (Req 4.3).
 */
export function pendingReviewLinkTarget(pendingAssessmentIds: number[]): string {
  return pendingAssessmentIds.length === 1
    ? `/assessments/${pendingAssessmentIds[0]}/review`
    : PENDING_REVIEW_FILTERED_LIST_ROUTE;
}
